export default __webpack_public_path__ + "static/media/jeep.cfa68f13.svg";